// import Repository from "./BaseRepositoryFactory";
import Repository from "./CeraBaseRepositoryFactory"
const DISPLAY_CARD_OPTIONS="getService";
const CREATE_ORDER = "create"
const CREATE_REQUEST="addRequest"


export default {
    getCARDOPTIONS(payload){ 
      return Repository.post(transformRoute(DISPLAY_CARD_OPTIONS),payload);
    },
    
    createOrder(payload){
      return Repository.post(transformRoute1(CREATE_ORDER),payload);
  },
    createRequest(payload){
      return Repository.post(transformRoute2(CREATE_REQUEST),payload);
    }
}
const transformRoute = route => {
  return `/studio/services/${route}`;
};
const transformRoute1 = route => {
    return `/studio/orders/${route}`;
};
const transformRoute2 = route => {
    return `/studio/request/${route}`;
  };